import type { BaseKeyFunction } from "../../../lib/types/baseKeyFunction";

export type KeyTranscriptProps = {
  id: number;
};

export const keyTranscript: BaseKeyFunction<KeyTranscriptProps> = ({ id }) => [
  "transcript",
  id?.toString(),
];
